// Image optimization utilities for better performance
export const getOptimizedImageProps = (src, alt, options = {}) => {
    const { priority = false, sizes, className = '' } = options;
    return {
        src,
        alt,
        className: `${className} ${priority ? '' : 'opacity-0'}`.trim(),
        sizes: sizes || '(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 33vw',
        loading: priority ? 'eager' : 'lazy',
        decoding: 'async',
        onLoad: (e) => {
            const img = e.target;
            img.style.opacity = '1';
            if (options.onLoad) {
                options.onLoad(e);
            }
        },
        style: {
            opacity: priority ? 1 : 0,
            transition: 'opacity 0.3s ease-in-out'
        }
    };
};
// Generate responsive image sources for different screen sizes
export const generateResponsiveSources = (src, widths = [400, 800, 1200]) => {
    return widths.map(width => ({
        src: `${src}?w=${width}`,
        media: `(max-width: ${width}px)`,
        width
    }));
};
// Preload critical images
export const preloadImages = (srcs) => {
    srcs.forEach(src => {
        const link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'image';
        link.href = src;
        document.head.appendChild(link);
    });
};
